export default __webpack_public_path__ + "static/media/Factory04.29d6a795.jpg";